import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { resource } from '@util/resource';
import { DWS } from '@interfaces/dws';

@Injectable({
  providedIn: 'root'
})
export class WineryChannelsService {
  constructor() {
  }

  getCategories(id: string): Observable<any[]> {
    return resource('crm://winery-channels/id/categories')
      .params({ id: id })
      .get();
  }

  getProducts(id: string): Observable<any[]> {
    return resource('crm://winery-channels/id/products')
        .params({ id: id })
        .get();
  }

  list(filter: WineryChannelsFilter, page: number = 0, count: number = 999999): Observable<DWS.Page<DWS.WineryChannel>> {
    if (!filter || !filter.wineryId && !filter.wineryId.length) {
      return of();
    }
    return resource('crm://winery-channels')
      .params({ ...filter, page, count })
      .get<DWS.Page<DWS.WineryChannel>>();
  }

  update(wineryChannelId: string, wineryChannel: DWS.WineryChannel): Observable<DWS.WineryChannel> {
    return resource('crm://winery-channels/id')
        .params({ id: wineryChannelId })
        .put<DWS.WineryChannel>(wineryChannel);
  }
}

export interface WineryChannelsFilter {
  wineryId: string;
}
